// 定員人数によってjson keyを所得
function convertNumIntoRoom(num, capaPerRoom) {

  const rooms = Math.ceil(num/capaPerRoom);

  if (rooms === 0 ||rooms > 200) {
    throw new Error(`${rooms}の値が0、または200を超えています。`);
  }

  if (rooms < 26) {
    return "num25"
  } else if (rooms >= 26 && rooms < 51) {
    return "num26_50"
  } else if (rooms >= 51 && rooms < 81) {
    return "num51_80"
  } else if (rooms >= 81 && rooms < 101) {
    return "num81_100"
  } else if (rooms >= 101 && rooms < 151) {
    return "num101_150"
  } else if (rooms >= 151 && rooms < 201) {
    return "num151_200"
  }

}

module.exports = {
  convertNumIntoRoom
}
